import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const CloseDialogAction = (props: { isProcessing?: boolean, onCancel: () => void }) => {
  return <IconButton disabled={props.isProcessing}
    onClick={props.onCancel}
    sx={{
      color: (theme) => theme.palette.custom.gray[800],
      mr: '-12px',
    }}
  >
    <CloseIcon />
  </IconButton>;
};